import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  type QuickBooksExportableItemReceiptConstructor,
  QuickBooksExportableItemReceipt,
} from './QuickBooksExportableItemReceipt'
import { ItemReceiptLineConstructorFactory } from '../ItemReceiptLine'

export const QuickBooksExportableItemReceiptConstructorFactory =
  Factory.Sync.makeFactory<QuickBooksExportableItemReceiptConstructor>({
    id: Factory.each(() => faker.random.number()),
    purchaseOrderLabel: Factory.each(() => `PO-${faker.random.number(9999)}`),
    poUuid: Factory.each(() => faker.random.uuid()),
    date: Factory.each(() => faker.date.past()),
    receiverName: Factory.each(
      () => `${faker.name.firstName()} ${faker.name.lastName()}`
    ),
    items: Factory.each(() => [ItemReceiptLineConstructorFactory.build()]),
    stagedForExport: false,
  })

export const QuickBooksExportableItemReceiptFactory = EntityFactory(
  QuickBooksExportableItemReceipt,
  QuickBooksExportableItemReceiptConstructorFactory
)
